import { render, staticRenderFns } from "./JCommFileManager.vue?vue&type=template&id=1373becc&scoped=true&"
import script from "./JCommFileManager.vue?vue&type=script&lang=js&"
export * from "./JCommFileManager.vue?vue&type=script&lang=js&"
import style0 from "./JCommFileManager.vue?vue&type=style&index=0&id=1373becc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373becc",
  null
  
)

export default component.exports